import { render } from "./TheCollectMaterial.vue?vue&type=template&id=8832b4ae&scoped=true"
import script from "./TheCollectMaterial.vue?vue&type=script&lang=js"
export * from "./TheCollectMaterial.vue?vue&type=script&lang=js"

import "./TheCollectMaterial.vue?vue&type=style&index=0&id=8832b4ae&scoped=true&lang=scss"

import exportComponent from "/data/jenkins/workspace/yh-node-yh-mallrobot-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8832b4ae"]])

export default __exports__